<template>
  <section>
    <h1 class="section-head"></h1>
    <div class="columns">
      <div class="column is-8">
        <h4 class="section-mini-head">รายงานยอดขายผลิตภัณฑ์ตามรายชื่อพนักงาน</h4>
        <highcharts :options="chartRevenueOptions" v-if="filteredData.length > 0 || isTableLoading"></highcharts>
        <highcharts :options="chartProductOptions" v-if="filteredData.length > 0 || isTableLoading"></highcharts>
      </div>
      <div class="column">
        <h4 class="section-mini-head">Filter Options</h4>
        <b-field label="ชื่อพนักงาน">
          <b-autocomplete
            v-model="employeeFilterName"
            placeholder="ชื่อพนักงาน"
            :clear-on-select="false"
            :keep-first="true"
            :open-on-focus="true"
            :data="filteredEmployeeObj"
            field="full_name"
            :disabled="employeeList.length < 1"
          >
          </b-autocomplete>
        </b-field>

        <b-field label="เริ่มต้น">
          <b-datepicker v-model="dateStart" :date-formatter="clean_date" placeholder="กดเพื่อเลือกวันเริ่มต้น.." icon="calendar"> </b-datepicker>
        </b-field>

        <b-field label="จนถึง">
          <b-datepicker v-model="dateEnd" :date-formatter="clean_date" placeholder="กดเพื่อเลือกวัน.." icon="calendar"> </b-datepicker>
        </b-field>
        <p class="section-mini-head"></p>
        <div class="buttons">
          <b-button type="is-info" icon-left="search" @click="getOrder()" expanded>Submit</b-button>
        </div>

        <p class="section-mini-head">ภาพรวม</p>
        <div class="notification">
          <div class="content">
            <h4>
              ยอดขาย
            </h4>
            <h2 class="is-marginless">{{ parseFloat(this.grandTotal).formatMoney(2) }} บาท</h2>
            <p>
              ยอดก่อนลดราคา
              {{ parseFloat(this.grandTotal + this.totalDiscount).formatMoney(2) }}
              บาท
            </p>
          </div>
          <hr />
          <div class="content">
            <h4>
              ส่วนลด
            </h4>
            <h2 class="is-marginless">{{ parseFloat(this.totalDiscount).formatMoney(2) }} บาท</h2>
            <p>
              คิดเป็น
              {{ parseFloat((this.totalDiscount / (this.grandTotal + this.totalDiscount)) * 100).formatMoney(2) }}% ของยอดขาย
            </p>
          </div>
          <hr />
          <div class="content">
            <h4>
              จำนวนพนักงานที่มียอดขาย
            </h4>
            <h2 class="is-marginless">
              {{ parseFloat(this.chartRevenueOptions.xAxis.categories.length).formatMoney(0) }}
              ราย
            </h2>
          </div>
          <hr />
          <div class="content">
            <h4>
              จำนวนคำสั่งซื้อ
            </h4>
            <h2 class="is-marginless">{{ parseFloat(filteredData.length).formatMoney(0) }} คำสั่ง</h2>
          </div>
          <hr />
          <div class="content">
            <h4>
              ประเภทสินค้า
            </h4>
            <h2 class="is-marginless">
              {{ parseFloat(this.chartProductOptions.xAxis.categories.length).formatMoney(0) }}
              ประเภท
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UserModel from '@/model/user_model';
import OrderModel from '@/model/order_model';
import Request from '@/libraries/request';
import Const from '@/const/const';
import moment from 'moment';
import Highcharts from 'highcharts';

import { Chart } from 'highcharts-vue';

export default {
  name: 'Report_order',
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      orders: [],
      product_filter: '',
      employeeList: [],
      productList: [],
      employeeFilterName: '',
      dateStart: new Date(),
      dateEnd: new Date(),
      dataList: {},
      isLoading: true,
      isTableLoading: false,

      grandTotal: 0.0,
      chartData: [],

      categoriesData: [],
      seriesData: [],
      totalDiscount: 0.0,

      isPaginated: true,
      isPaginationSimple: false,
      currentPage: 1,
      perPage: 20,
      chartHeight: 400,

      chartRevenueOptions: {
        chart: {
          type: 'bar',
          height: 400,
        },
        title: {
          text: 'รายงานยอดขายผลิตภัณฑ์ (แยกตามพนักงาน)',
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          lineHeight: 10,
          type: 'logarithmic',
          title: {
            text: '<b>จำนวน (บาท)</b>',
          },
        },
        tooltip: {
          formatter: function() {
            return this.x + '<br><strong>' + Highcharts.numberFormat(this.y, 2, '.', ',') + ' บาท </strong>';
          },
          headerFormat: '<b>{categories.name}</b><br />',
          //pointFormat: Highcharts.numberFormat(this.y, 0) +' บาท'
        },

        legend: {},
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
        series: [
          {
            name: 'รายได้',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
        ],
      },
      chartProductOptions: {
        chart: {
          type: 'bar',
          height: 400,
        },
        title: {
          text: 'รายงานยอดขายผลิตภัณฑ์ (แยกตามผลิตภัณฑ์)',
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          lineHeight: 10,
          type: 'logarithmic',
          title: {
            text: '<b>จำนวน (บาท)</b>',
          },
        },
        tooltip: {
          formatter: function() {
            return this.points.reduce(function(s, point) {
              return s + '<br/>' + point.series.name + ': ' + Highcharts.numberFormat(point.y, 2, '.', ',') + ' ' + (point.colorIndex == 1 ? point.series.options.unit[point.point.index] : 'บาท');
            }, '<b>' + this.x + '</b>');
          },
          shared: true,
          //pointFormat: Highcharts.numberFormat(this.y, 0) +' บาท'
        },

        legend: {},
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: 'มูลค่าขาย',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
          {
            name: 'จำนวน',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
          {
            name: 'ส่วนลด',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.isLoading = true;
    this.init();
  },
  computed: {
    filteredEmployeeObj() {
      return this.employeeList.filter(option => {
        if (option.full_name.toLowerCase().indexOf(this.employeeFilterName.toLowerCase()) >= 0) {
          return option;
        } else {
          return false;
        }
      });
    },
    filteredProduct() {
      return this.productList.filter(option => {
        if (option.name.toLowerCase().indexOf(this.product_filter.toLowerCase()) >= 0) {
          return option;
        } else {
          return false;
        }
      });
    },
    filteredData: function() {
      this.grandTotal = 0;
      this.chartData = [];
      return this.orders.filter(order => {
        if (order.full_name && order.full_name.toLowerCase().includes(this.employeeFilterName.toLowerCase())) {
          this.recalculateData(order);
          return true;
        } else {
          return false;
        }
      });
    },
  },
  methods: {
    async init() {
      this.isLoading = true;
      const employeeList = await UserModel.get_users();
      employeeList.forEach(function(order, index) {
        employeeList[index].full_name = `${order.first_name} ${order.last_name}`;
      });
      this.employeeList = employeeList;
      Request.get('product', res => {
        // this.loadingComponent.close();
        this.isLoading = false;
        if (res.data.status) {
          this.productList = res.data.data;
        }
      });
    },
    async getOrder() {
      this.isTableLoading = true;
      const orders = await OrderModel.get_order_by_date_range(moment(this.dateStart).format('YYYY-MM-DD 00:00:00'), moment(this.dateEnd).format('YYYY-MM-DD 23:59:59'));
      orders.forEach(function(order, index) {
        orders[index].full_name = `${order.first_name} ${order.last_name}`;
      });
      this.orders = orders;
      this.isTableLoading = false;
    },
    recalculateData(data) {
      this.chartData.push(data);
      let self = this;
      //Manipulate Data for chart display

      let groupedData = this.groupBy(this.chartData, 'cr_uid');
      let reArrangedRevenueDatas = [];
      let productDatas = [];
      //console.log(typeof groupedData);
      //console.log(groupedData);

      groupedData.forEach(function(groupedDatas, index) {
        reArrangedRevenueDatas[index] = {
          name: '',
          total: 0.0,
        };
        groupedDatas.forEach((groupedData, dataIndex) => {
          // reArrangedRevenueDatas[index].name = groupedData.company;
          reArrangedRevenueDatas[index].name = groupedData.full_name;

          //Product
          groupedData.items.forEach((itemData, itemIndex) => {
            productDatas.push(itemData);
            reArrangedRevenueDatas[index].total = parseFloat(reArrangedRevenueDatas[index].total) + parseFloat(itemData.total_price);
          });
        });
      });

      let groupedProductData = this.groupBy(productDatas, 'pro_id');
      //console.log(groupedProductData);
      let reArrangedProductDatas = [];
      groupedProductData.forEach((productData, productIndex) => {
        reArrangedProductDatas[productIndex] = {
          id: 0,
          name: '',
          unit: '',
          total_discount: 0.0,
          total_price: 0.0,
          total_amount: 0.0,
        };
        productData.forEach((item, index) => {
          reArrangedProductDatas[productIndex].id = item.pro_id;
          reArrangedProductDatas[productIndex].name = item.name;
          reArrangedProductDatas[productIndex].unit = Const.product_unit[item.unit];
          reArrangedProductDatas[productIndex].total_discount +=
            parseFloat(item.price * item.amount) - parseFloat(item.total_price) ? parseFloat(item.price * item.amount) - parseFloat(item.total_price) : 0;
          reArrangedProductDatas[productIndex].total_amount += parseFloat(item.amount) ? parseFloat(item.amount) : 0;
          reArrangedProductDatas[productIndex].total_price += parseFloat(item.total_price) ? parseFloat(item.total_price) : 0;
        });
      });

      //console.log(reArrangedProductDatas);
      reArrangedProductDatas.sort((a, b) => b.total_price - a.total_price);
      let categoriesProductData = [];
      let seriesProductUnitData = [];
      let seriesPriceProductData = [];
      let seriesAmountProductData = [];
      let seriesDiscountProductData = [];
      this.totalDiscount = 0.0;
      reArrangedProductDatas.forEach((reArrangedProductData, reArrangedProductDataIndex) => {
        categoriesProductData.push(reArrangedProductData.name);
        seriesProductUnitData.push(reArrangedProductData.unit);
        seriesPriceProductData.push(reArrangedProductData.total_price);
        seriesAmountProductData.push(reArrangedProductData.total_amount);
        seriesDiscountProductData.push(reArrangedProductData.total_discount);
        this.totalDiscount += reArrangedProductData.total_discount;
      });

      this.chartProductOptions.xAxis.categories = categoriesProductData;
      this.chartProductOptions.series[0].data = seriesPriceProductData;
      this.chartProductOptions.series[1].data = seriesAmountProductData;
      this.chartProductOptions.series[1].unit = seriesProductUnitData;
      this.chartProductOptions.series[2].data = seriesDiscountProductData;

      this.chartProductOptions.chart.height = categoriesProductData.length * 50 < 500 ? 500 : categoriesProductData.length * 50;

      reArrangedRevenueDatas.sort((a, b) => b.total - a.total);

      let categoriesData = [];
      let seriesData = [];
      let grandTotal = 0.0;
      reArrangedRevenueDatas.forEach((reArrangedData, reArrangedDataIndex) => {
        if (reArrangedData.total > 0) {
          categoriesData.push(reArrangedData.name);
          seriesData.push(reArrangedData.total);
          grandTotal = parseFloat(grandTotal) + parseFloat(reArrangedData.total);
        }
      });

      this.grandTotal = grandTotal;
      this.chartRevenueOptions.xAxis.categories = categoriesData;
      this.chartRevenueOptions.series[0].data = seriesData;

      this.chartRevenueOptions.chart.height = categoriesData.length * 30 < 400 ? 400 : categoriesData.length * 30;
      //console.log(reArrangedData);
      //console.log(this.chartRevenueOptions.xAxis.categories);
      //console.log(this.chartRevenueOptions.series[0].data);
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, []);
    },
    clean_date(date) {
      return moment(date).format('YYYY-MM-DD');
    },
  },
};
</script>

<style>
.highchart-box {
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Report/order_sales.vue